export { default } from "./CustomIcon-component";
